module.exports = "<svg viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 0L29.8795 18.1266L48 18.3291L33.4458 29.7722L38.8434 48L24 36.962L9.15663 48L14.5542 29.7722L0 18.3291L18.2169 18.1266L24 0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/star.svg
// module id = 551
// module chunks = 1